// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Jp-z","breadcrumbForward":"Kp-z","breadcrumbBack":"Lp-z","selected":"Mp-z"};